<template>
  <jc-dialog ref="createDialog" :show.sync="show"
             btn-confirm-text='<i class="fas fa-save"></i> Lưu'
             title="Thêm mới"
             type="green"
             @onConfirm="$refs.form.submit()"
  >
    <c-form ref="form" @submit="submit()">
      <c-select2 v-model.number="model.resourceId"
                 label="Tài nguyên"
                 placeholder="Nhập mã tài nguyên"
                 uri="cms/api/v1.0/admin/resources/select2"
                 validate-rules="required"
      />

      <c-select2 v-model.number="model.actionId"
                 label="Hành động"
                 placeholder="Nhập tên shop hoặc mã shop"
                 uri="cms/api/v1.0/admin/actions/select2"
                 validate-rules="required"
      />

    </c-form>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "add",
  mixins: [
    dialogMixins,
  ],
  data: function () {
    return {
      model: {
        resourceId: null,
        actionId: null,
      },
    }
  },
  methods: {
    resetForm() {
      this.model = {
        resourceId: null,
        actionId: null,
      };
    },
    submit() {
      this.$showLoader();
      let data = {
        "resourceId": this.model.resourceId,
        "actionId": this.model.actionId
      }
      this.$http
          .post('/cms/api/v1.0/admin/permission', data)
          .then(successRes => {
            this.$success();
            this.$stopLoader();
            this.model.actionId = null;
            this.$refs.form.reset();

            this.$emit("success", successRes);
          }, errorRes => {
            this.$stopLoader();
            this.errorNotify(errorRes)
                .then(errorRes => this.$cmsBadRequest(errorRes));
            this.$emit("error", errorRes);
          })
      ;
    }
  }
}
</script>

<style scoped>

</style>